import styled from "styled-components";

export const StyledFormWrapper = styled.div`
    max-width: 460px;
    min-width: 250px;
    width: 100%;
    margin: 1rem;
    padding: 1.5rem;
    background-color: #fff;
`;
